import ApiRequest from '../../utils/APIRequest';

export default class appointmentModelAppointment {
  getIncomingAppointment = async () => {
    return await ApiRequest.set('v1/appointment-user/incoming', 'GET');
  };

  getAppointmentByDate = async (startDate, endDate) => {
    console.log("APS DATE",startDate, endDate)
    return await ApiRequest.set(`v2/appointment-user/date?start_date=${startDate}&end_date=${endDate}`, 'GET');
  };

  getDoctorAppointmentByWeekForDoctor = async(dateStart, dateEnd) => {
    return await ApiRequest.set(`v2/appointment-user/date?start_date=${dateStart}&end_date=${dateEnd}`, 'POST',{});
}

  getAppointmentByDateAndClinicId = async (startDate, endDate, clinicId) => {
    return await ApiRequest.set(`v1/appointment-user/date/clinic`, 'POST', {start_date: startDate, end_date: endDate, clinic_id: clinicId});
  };

  getOwnedAppointmentByDateAndClinicId = async (startDate, endDate, clinicId) => {
    return await ApiRequest.set(`v1/appointment-user/date/clinic/owned`, 'POST', {start_date: startDate, end_date: endDate, clinic_id: clinicId});
  };

  confirmAppointment = async (id, start_time, end_time, operation_table_id) => {

    console.log("PARAM", id, start_time, end_time, operation_table_id)

    let params = {
      appointment_userid : id,
      start_time, end_time, operation_table_id
    }

    if(!operation_table_id){
      delete params.operation_table_id
    }

    return await ApiRequest.set('v1/appointment-user/confirm', 'POST',{
      ...params
    });
  };

  getMedicalRecordAppointment = async () => {
    return await ApiRequest.set('v1/appointment-user/done', 'GET');
  };

  getMedicalRecordAppointmentForDoctor = async () => {
    return await ApiRequest.set('v1/appointment-user/done', 'POST');
  };

  editAppointment = async (id, values) => {

    return await ApiRequest.set('v1/appointment-user/'+id, 'PUT', values);
  };

  editAppointmentSlot = async (id, values) => {

    return await ApiRequest.set('v1/appointment-slot/timeslot/'+id, 'PUT', values);
  };

  blockAppointmentSlot = async (id, values) => {
    return await ApiRequest.set('v1/appointment-slot/timeslot-ban/'+id, 'PUT', values);
  };

  appointmentEditDoctorID = async (values) => {
    console.log("sending", values)
    return await ApiRequest.set('v1/appointment-slot/edit_doctor_id', 'POST', values);
  };

  appointmentEditOwnerIDAndPatientID = async (values) => {
    console.log("sending", values)
    return await ApiRequest.set('v1/appointment/patient_owner/edit', 'PUT', values);
  };

  rejectAppointment = async (userId, reason) => {
    return await ApiRequest.set('v1/appointment-user/reject', 'DELETE', {
      appointment_userid : userId,
      description : reason
    });
  };

}
